import React, { useMemo } from 'react';
import { Timecode } from '../types';
import { formatTimecode, secondsToTimecode, timeToFrame } from '../hooks/useTimecode';

interface TimecodeDisplayProps {
  timecode?: Timecode;
  timeInSeconds?: number;
  className?: string;
  inPoint?: number;
  fps?: number;
  onClick?: () => void;
}

const TimecodeDisplay: React.FC<TimecodeDisplayProps> = ({
  timecode,
  timeInSeconds,
  className,
  inPoint,
  fps,
  onClick,
}) => {
  const displayFrame = useMemo(() => {
    if (timeInSeconds !== undefined && inPoint !== undefined && fps !== undefined) {
      return inPoint + timeToFrame(timeInSeconds, fps);
    }
    if (timecode && fps !== undefined) {
      const totalFrames = timecode.minutes * 60 * fps + timecode.seconds * fps + timecode.frames;
      return inPoint !== undefined ? inPoint + totalFrames : totalFrames;
    }
    return null;
  }, [timecode, timeInSeconds, inPoint, fps]);

  const displayTimecode = useMemo(() => {
    if (timecode) return timecode;
    if (timeInSeconds !== undefined && fps !== undefined) {
      return secondsToTimecode(timeInSeconds, fps);
    }
    return { minutes: 0, seconds: 0, frames: 0 };
  }, [timecode, timeInSeconds, fps]);

  const content =
    displayFrame !== null ? `Frame ${displayFrame}` : formatTimecode(displayTimecode);

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`font-mono text-sm text-indigo-400 hover:text-indigo-300 ${className || ''}`}
      >
        {content}
      </button>
    );
  }

  return <span className={`font-mono text-sm ${className || ''}`}>{content}</span>;
};

export default TimecodeDisplay;
